import { colors } from "healthex-common/colors";
import styled from "styled-components";
import { FlexColumnDiv, FlexRowDiv } from "./common.styles";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
export const PatientRecordsSummaryContainer = styled(FlexColumnDiv) `
    position: relative;
    width: 100%;
    border-radius: 12px;
    border: 1px solid ${colors.blue_10};
    overflow: hidden;
    cursor: pointer;
`;
export const GradientBar = styled.div `
    width: 100%;
    height: 8px;
    background: linear-gradient(135deg, ${colors.accents_gradient_start} 0%, ${colors.accents_sunset} 100%);
`;
export const SummaryCard = styled(FlexColumnDiv) `
    align-self: stretch;
    padding: 16px;
    gap: 4px;
    background-color: ${colors.white_background};
`;
export const Header = styled(FlexColumnDiv) `
    gap: 4px;
`;
export const HeaderTitle = styled.div `
    align-self: left;
    text-align: left;
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.black_light};
`;
export const HeaderTitleBold = styled.div `
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.BOLD};
    color: ${colors.black_light};
    display: inline;
`;
export const HeaderText = styled.div `
    align-self: left;
    text-align: left;
    font-size: ${fontSizes.TINY};
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.black_light};
`;
export const HeaderTextBold = styled.div `
    font-size: ${fontSizes.TINY};
    font-weight: ${fontWeights.BOLD};
    color: ${colors.black_light};
    display: inline;
`;
export const DividerContainer = styled.div `
    display: flex;
    height: 16px;
    align-items: center;
    gap: 16px;
`;
export const DividerInternal = styled.div `
    width: 100%;
    height: 1px;
    background-color: ${colors.blue_10};
`;
export const Findings = styled(FlexColumnDiv) `
    gap: 12px;
`;
export const FindingItemContainer = styled(FlexRowDiv) `
    align-items: center;
    gap: 4px;
    align-self: stretch;
`;
export const FindingItemIcon = styled.div `
    width: 16px;
    height: 16px;
    align-items: center;
    justify-items: center;
`;
export const FindingItemLabel = styled.div `
    font-size: ${fontSizes.TINY};
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.black_light};
`;
export const FindingItemText = styled.div `
    font-size: ${fontSizes.TINY};
    font-weight: ${fontWeights.BOLD};
    color: ${colors.black_light};
`;
export const Fade = styled.div `
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 60px;
    pointer-events: none;
    background: linear-gradient(180deg, ${colors.white_background_gradient_start} 0%, ${colors.white_background} 75%);
`;
